import { Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { useElements } from '../../elements-context';
import { LibTimer } from './lib-timer';
import { NumberCounter } from './number-counter';

export function Timer() {
  const { timerType } = useSettings();
  const {
    timer: {
      ref,
      handleCountdownFinish,
      handleCountdownReset,
      handleCountdownRestart,
      isVisible
    }
  } = useElements();

  const props = {
    ref,
    style: isVisible ? undefined : { display: 'none' },
    className: createReadableClass({
      component: `element-timer`,
      element: 'container',
      index: timerType
    }),
    onCountdownFinish: handleCountdownFinish,
    onCountdownReset: handleCountdownReset,
    onCountdownRestart: handleCountdownRestart
  };

  return (
    <Show when={timerType === 'number'} fallback={<LibTimer {...props} />}>
      <NumberCounter {...props} />
    </Show>
  );
}
